import React from "react";
import LayoutOperacionesAliado from "../../components/aliadosOperaciones/LayoutOperacionesAliado";
import PagosNaranjaAliado from "../../components/aliadosOperaciones/PagosNaranjaAliado";

const PagosNaranjaClienteAliado = () => (
  <LayoutOperacionesAliado title="Pagos Naranja">
    <PagosNaranjaAliado />
  </LayoutOperacionesAliado>
);

export default PagosNaranjaClienteAliado;
